<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:33:45
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id='main-container' class="main-container">
                <div class='box' v-if='activity.activityCurrentStatus !== 3' ref='box'>
                    <div class='cBox'>
                        <h4 class='boxH4'>
                            <span v-for='item in preferentialConfigList' :key='item'>{{item}}</span>
                        </h4>
                        <p class='cp'>
                            活动时间：{{activity.activityTimeRange}}
                        </p>
                    </div>
                </div>
                <div class='list' v-if='activity.activityCurrentStatus !== 3'>
                    <div class='listleft' v-if='productBaseInfoList.length > 0'>
                        <van-col class='ffBg' v-if='index%2===0' v-for='(item,index) in activityDetails.productBaseInfoList' :key='item'>
                            <div @click='toDetails(item)'>
                                <div class='imgBox'>
                                    <img :src="item.image" alt="">
                                </div>
                                <p class='p1'>{{item.name}}
                                </p>
                                <p class='p2'>
                                    <span>¥{{ESVBase.numberTofixed(item.minPrice)}}</span>
                                </p>
                            </div>
                        </van-col>
                    </div>
                    <div class='listright' v-if='productBaseInfoList.length > 0'>
                        <van-col class='ffBg' v-if='index%2===1' v-for='(item,index) in activityDetails.productBaseInfoList' :key='item'>
                            <div @click='toDetails(item)'>
                                <div class='imgBox'>
                                    <img :src="item.image" alt="">
                                </div>
                                <p class='p1'>{{item.name}}
                                </p>
                                <p class='p2'>
                                    <span>¥{{ESVBase.numberTofixed(item.minPrice)}}</span>
                                </p>
                            </div>
                        </van-col>
                    </div>
                    <div v-if='productBaseInfoList.length <= 0' class='kBox'>
                        <img :src="noProductUrl" alt="">
                        <p>暂无商品！</p>
                    </div>
                </div>
                <div v-if='activity.activityCurrentStatus === 3' class='gBox'>
                    <img :src="noActivityUrl" alt="">
                    <p>活动已过期！</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vant';
export default {
    components: {
        Icon
    },
    data() {
        return {
            heightNew: '79px',
            activityDetails: {},
            activity: {},
            noActivityUrl: require('../assets/img/myCenter/noActivity.png'),
            noProductUrl: require('../assets/img/myCenter/noProduct.png'),
            productBaseInfoList: [],
            preferentialConfigList: []
        };
    },
    esvReady() {
        const ths = this;
        document.title = '满减活动';
        this.ESVStorage.getSavedValue('activityDetails', (data) => {
            ths.activityDetails = data;
        });
        this.activity = this.activityDetails.activity;
        this.productBaseInfoList = this.activityDetails.productBaseInfoList;
        this.preferentialConfigList = this.activityDetails.preferentialConfigList;
    },
    esvShow() {},
    mounted() {},
    methods: {
        toDetails(item) {
            this.ESVStorage.putSavedValue('goodsId', item.productId);
            this.esvOpenPage({
                name: 'OPGoodsdetail',
                params: { goodsId: item.productId }
            });
        },
        addCart(item) {}
    }
};
</script>
<style lang="scss" scoped>
.kBox {
    width: 100%;
}
.box {
    background: #ee2e50;
    padding: 10px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    .cBox {
        background: #fff;
        h4 {
            text-align: left;
            border-bottom: 1px solid #f2f2f2;
            margin: 10px;
            padding-top: 10px;
            span {
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #ee2e50;
                letter-spacing: 0;
                display: inline-block;
                padding: 0 10px;
                height: 40px;
                line-height: 40px;
                border: 1px solid #ee2e50;
                background: rgba(255, 0, 65, 0.3);
                margin-bottom: 10px;
                margin-right: 8px;
            }
        }
        p {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #414141;
            letter-spacing: 0;
            text-align: left;
            padding: 10px;
        }
    }
}
.list {
    overflow: hidden;
    width: 100%;
    margin-bottom: 10px;
}
.listleft {
    width: 50%;
    float: left;
}
.listright {
    width: 50%;
    float: left;
}
.ffBg {
    background: #fff;
    margin-bottom: 12px;
    width: 96%;
    margin: 0 2%;
    margin-top: 12px;
    height: 254px;
    .imgBox {
        padding: 12px;
        line-height: 132px;
        height: 156px;
        box-sizing: content-box;
        img {
            width: 100%;
            max-height: 156px;
            vertical-align: middle;
            display: inline-block;
        }
    }
    .p1 {
        padding: 0 12px;
        height: 36px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .p2 {
        padding: 0 12px;
        span {
            color: #ee2e3a;
            padding: 10px 0;
            float: left;
        }
    }
}
.boxH4 {
    span {
        margin-right: 8px;
    }
}
.kBox {
    text-align: center;
    img {
        width: 203px;
        margin-top: 100px;
    }
    p {
        color: #999;
        padding-top: 20px;
        text-align: center;
    }
}
.gBox {
    text-align: center;
    img {
        width: 203px;
        margin-top: 100px;
    }
    p {
        color: #999;
        padding-top: 20px;
        text-align: center;
    }
}
</style>
